import React from 'react';
import theme from './FormContainer.module.scss';
import { classnames } from '@ygtechnologies/bygr-frontend-component-library';

export interface FormContainerProps {
    maxSize?: string;
    className?: string;
}

export const FormContainer: React.FC<FormContainerProps> = ({ maxSize, className, children }) => {
    return (
        <div className={classnames(theme.container, className)} style={{ '--max-size': maxSize } as any}>
            {children}
        </div>
    );
};
